module.exports = import("https://static.cloud.coveo.com/atomic/v2.59.0/index.esm.js");;